








import { remittanceInvoiceDetails } from '@/api/Remittances/remittances.api'
import ActionButton from '@/components/ActionButton.vue'
import { Remittance } from '@/utils/interfaces/remittance.interface'
import Vue, { PropType } from 'vue'
import { generateFile } from '~/utils/functions'
export default Vue.extend({
  components: { ActionButton },
  props: {
    remittance: Object as PropType<Remittance>,
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async onClick() {
      this.loading = true
      try {
        const response = await remittanceInvoiceDetails(this.remittance.uuid)
        generateFile(response, `invoice-${this.remittance.code}.pdf`)
      } finally {
        this.loading = false
      }
    },
  },
})
